import React, { useState, useEffect, useCallback } from "react";
import useAlert from "../../hooks/use-alert";
import CorporationDataService from "../../services/corporation.data.service";
import GenericAlert from "../Alert/GenericAlert";
import CrudContent from "../CrudContent/CrudContent";
import Header from "../Header/Header";
import CorporationForm from "./CorporationForm";

const Corporation = () => {
  const [allCorporations, setAllCorporations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isUnauthorized, setIsUnauthorized] = useState(false);
  const [error, setError] = useState(false);
  const { show, alertContent, handleAlertVisible } = useAlert();

  // The header of the table
  const header = ["Id", "Name", "Bearbeiten"];

  //const headers = ["Id", "Name"];

  // The variables for the modals (add, delete, edit)
  const modalTitle = "Gesellschaft löschen";
  const modalTitleEdit = "Gesellschaft bearbeiten";
  const modalTitleAdd = "Gesellschaft hinzufügen";
  const modalBody = "Möchten Sie die Gesellschft wirklich löschen?";

  // The data to be edited
  const [editData, setEditData] = useState({});

  // The filter value out of the filter input on top of the table
  const [filter, setFilter] = useState({ filter: "" });

  // Count of header items that need to be skipped
  const skip = 1;

  // Function to get all corporations out of the database
  const getAllCorporations = useCallback(() => {
    CorporationDataService.getAll(filter)
      .then((response) => {
        if (response.data.length !== 0) {
          var corp = [];
          response.data.forEach((element) => {
            corp.push({
              id: element.id,
              name: element.name,
            });
          });
          setAllCorporations(corp);
        } else {
          setAllCorporations([]);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401) {
            setIsUnauthorized(true);
          } else {
            setError(true);
          }
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [filter]);

  // Calls the getAllCorporations() function every time the filter value changes
  useEffect(() => {
    getAllCorporations();
  }, [getAllCorporations]);

  // Function to delete a specific corporation item by id
  const deleteItem = (item) => {
    CorporationDataService.delete(item.id)
      .then((response) => {
        console.log(response);
        handleAlertVisible(
          "Erfolgreich gelöscht",
          'Die Gesellschaft "' + item.name + '" wurde erfolgreich gelöscht!',
          "success"
        );
        getAllCorporations();
      })
      .catch((error) => {
        handleAlertVisible(
          "Fehler",
          'Die Gesellschaft "' + item.name + '" konnte nicht gelöscht werden!',
          "danger"
        );
        console.log(error);
      });
  };

  // Function to edit an specific table record
  const editItem = (item) => {
    CorporationDataService.update(item.id, item)
      .then((response) => {
        console.log(response);
        handleAlertVisible(
          "Erfolgreich bearbeitet",
          'Die Gesellschaft "' + item.name + '" wurde erfolgreich bearbeitet!',
          "success"
        );
        getAllCorporations();
      })
      .catch((error) => {
        handleAlertVisible(
          "Fehler",
          'Die Gesellschaft "' +
            item.name +
            '" konnte nicht bearbeitet werden!',
          "danger"
        );
        console.log(error);
      });
  };

  // Function to add a new table record
  const addItem = (item) => {
    CorporationDataService.create(item)
      .then((response) => {
        handleAlertVisible(
          "Erfolgreich hinzugefügt",
          'Die Gesellschaft "' + item.name + '" wurde erfolgreich erstellt!',
          "success"
        );
        getAllCorporations();
      })
      .catch((error) => {
        handleAlertVisible(
          "Fehler",
          'Die Gesellschaft "' + item.name + '" konnte nicht erstellt werden!',
          "danger"
        );
        console.log(error);
      });
  };

  // Function to set the current filter value.
  const handleFilter = (filterValue) => {
    setFilter(filterValue);
  };

  // Function to set the current edit data.
  const handleEditItem = (item) => {
    setEditData(item);
  };

  return (
    <main>
      <Header />
      <div className="main">
        <CrudContent
          heading="Gesellschaften"
          items={allCorporations}
          header={header}
          onDelete={deleteItem}
          delete
          modalTitle={modalTitle}
          modalBody={modalBody}
          modalTitleEdit={modalTitleEdit}
          hasForm
          form={
            <CorporationForm
              editData={editData}
              btnText="Bearbeiten"
              isDisabled
            />
          }
          onEditItemReceive={handleEditItem}
          onEditItem={editItem}
          placeholder={"Filter Gesellschaften..."}
          modalTitleAdd={modalTitleAdd}
          formAdd={<CorporationForm btnText="Hinzufügen" />}
          onAddItem={addItem}
          add
          onFilter={handleFilter}
          skip={skip}
          moreInfo={false}
          edit
          loading={isLoading}
          unauthorized={isUnauthorized}
          error={error}
        />
        <GenericAlert
          show={show}
          alertVariant={alertContent.variant}
          alertHeading={alertContent.heading}
          alertBody={alertContent.message}
        />
      </div>
    </main>
  );
};

export default Corporation;
